import script from "./PiramideDeBird.vue?vue&type=script&setup=true&lang=js"
export * from "./PiramideDeBird.vue?vue&type=script&setup=true&lang=js"

import "./PiramideDeBird.vue?vue&type=style&index=0&id=17a4231a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a4231a"]])

export default __exports__